import { Component } from 'react';
import { emptyField, ErrorMessage, errorsLength, formatErrors } from '../../../../../../../../insfrastructure/utils/form-validators';
import { Input } from '../../../../../../../components/input';
import './styles.sass'

export class AboutCompany extends Component<{form_data: Record<string, any>, onSubmit: (form: Record<string, any>) => void, onBack?: () => void}> {

  state: any = {
    form: this.props.form_data,
    formErrors: {}
  }

  onSubmit = () => {
    const errors = formatErrors({
      description: [
        emptyField(this.state.form.description, 'string'),
        (this.state.form.description && this.state.form.description.length > 512) ? 'Certifique-se de que este campo não tenha mais de 512 caracteres.' : ''
      ],
      motivation: [
        emptyField(this.state.form.motivation, 'string'),
        (this.state.form.motivation && this.state.form.motivation.length > 512) ? 'Certifique-se de que este campo não tenha mais de 512 caracteres.' : ''
      ]
    });

    this.setState({ formErrors: errors });

    if(errorsLength(errors) > 0) return;

    try {
      setTimeout(() => {
        this.setState({ sended: true });
        this.props.onSubmit(this.state.form);
      });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className='form about-company'>
        <div className='form-container'>
          <div className='text'>
            <h4>Fale um pouco sobre a sua empresa.</h4>
            <p>As informações a serem compartilhadas aqui apareceram nos seus anúncios de vagas.</p>
          </div>
          <div className='columns'>
            <div className='column'>
              <Input
              name='description'
              label='Sobre a empresa'
              type='textarea'
              required={true}
              value={this.state.form.description}
              onChange={e => this.setState({ form: { ...this.state.form, description: e } })}/>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                <small style={{ fontSize: '12px', color: (this.state.form.description?.length || 0) > 512 ? '#D32F2F' : '#6B7280' }}>
                  {(this.state.form.description?.length || 0)}/512
                </small>
              </div>
              <ErrorMessage errors={this.state.formErrors['description']} />
            </div>
            <div className='column'>
              <Input
              name='motivation'
              label='Por que trabalhar com a gente?'
              type='textarea'
              required={true}
              value={this.state.form.motivation}
              onChange={e => this.setState({ form: { ...this.state.form, motivation: e } })}/>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                <small style={{ fontSize: '12px', color: (this.state.form.motivation?.length || 0) > 512 ? '#D32F2F' : '#6B7280' }}>
                  {(this.state.form.motivation?.length || 0)}/512
                </small>
              </div>
              <ErrorMessage errors={this.state.formErrors['motivation']} />
            </div>
          </div>
          <div className='columns' style={{ borderBottom: 'none', alignItems: 'center' }}>
            {this.props.onBack ? (
              <>
                <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                  <button className='secondary submit' onClick={this.props.onBack} style={{ width: '100%', margin: 0, border: '1px solid #105099' }}>Voltar</button>
                </div>
                <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                  <button className='primary submit' onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>Continuar</button>
                </div>
              </>
            ) : (
              <div className='column' style={{ borderRight: 'none', marginLeft: 'auto', width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                <button className='primary submit' onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>Continuar</button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
